import { Component, Injectable} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';
import {Subject} from "rxjs/Subject";


@Injectable()
export class FileUploadService {

    /**
     * @param Observable<number>
     */
    private progress$: Observable<number>;

    /**
     * @type {number}
     */
    private progress: number = 0;

    private progressObserver: any = new Subject<any>();

    constructor () {
//        this.progress$ = new Observable(observer => {
//            this.progressObserver = observer;
//            console.log("this.progressObserver", this.progressObserver);
//        });
        this.progress$ = this.progressObserver.asObservable();
        
    }

    /**
     * @returns {Observable<number>}
     */
    public getObserver (): Observable<number> {
        return this.progress$;
    }

    /**
     * Upload files through XMLHttpRequest
     *
     * @param url
     * @param files
     * @returns {Promise<T>}
     */
    public upload (url: string, formData: FormData, headers?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            FileUploadService.setUploadUpdateInterval(500);

            xhr.upload.onprogress = (event) => {
                this.progress = Math.round(event.loaded / event.total * 100);
                try{
                    this.progressObserver.next(this.progress);
                } catch(e){
                    console.log(e);
                }
            };

            xhr.open('POST', url, true);
            if(headers)
            headers.headers.forEach((o, i)=>{
                xhr.setRequestHeader(i, o.join(", "))
            })
            xhr.send(formData);
        });
    }

    /**
     * Set interval for frequency with which Observable inside Promise will share data with subscribers.
     *
     * @param interval
     */
    private static setUploadUpdateInterval (interval: number): void {
        setInterval(() => {}, interval);
    }
}


// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/file-upload.service.ts